import axios from 'axios';
import { ElMessage,ElMessageBox} from 'element-plus';
import sysConfig from "@/config";
import tool from '@/utils/tool';
import router from '@/router';
import {notification} from './notification';
axios.defaults.baseURL = sysConfig.API_URL
axios.defaults.timeout = sysConfig.TIMEOUT

// let pending = []
// const cancelToken = axios.CancelToken // 初始化取消请求的构造函数

// const removePending = (config, fn) => {
//   const arr = config.url.split('/api') // 处理 baseURL
//   const flagUrl = arr[arr.length - 1]
//   if (pending.includes(flagUrl)) {
// 		// console.log('重复了')
//     fn ? fn(flagMsg) : pending.splice(pending.indexOf(flagUrl), 1)
//   } else {
//     if (fn) {
// 			// console.log(flagUrl,"是否未重复的数据",pending)
//       pending.push(flagUrl)
//     }
//   }
// }
// HTTP request 拦截器
axios.interceptors.request.use(
	(config) => {
		let token = tool.cookie.get("TOKEN");
		if (token) {
			config.headers[sysConfig.TOKEN_NAME] = sysConfig.TOKEN_PREFIX + token
		}
		if (!sysConfig.REQUEST_CACHE && config.method == 'get') {
			config.params = config.params || {};
			config.params['_'] = new Date().getTime();
		}
		Object.assign(config.headers, sysConfig.HEADERS);
		// config.cancelToken = new cancelToken(c => {
		// 	removePending(config, c)
		// })
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);
let isToken = false;
// HTTP response 拦截器
axios.interceptors.response.use(
	(response)=>{
		// removePending(response?.config)
		const validArr = [0, 200];
		const code = response.data.code || response.status || 0;
		if (code === 10401) {
			if(!isToken){
				isToken = true;
				ElMessageBox.confirm('当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。', '无权限访问', {
					type: 'error',
					closeOnClickModal: false,
					center: true,
					confirmButtonText: '重新登录'
				}).then(() => {	
					router.replace({ path: '/login' })
				}).catch(() => {
				})
				return Promise.reject(response)
			}
		}
		if (!validArr.includes(Number(code))) {
			notification.error({
				title: '请求错误',
				message: response.data.msg || response.data.message
			});
			return Promise.reject(response);
		}
		
		return Promise.resolve(response);
	},
	(error) => {
		if (error&&error.response) {
			if (error.response.status == 404) {
				notification.error({
					title: '请求错误',
					message: "Status:404，正在请求不存在的服务器记录！"
				});
			} else if (error.response.status == 500) {
				notification.error({
					title: '请求错误',
					message: error.response.data.message || "Status:500，服务器发生错误！"
				});
			} else if (error.response.status == 401) {
				ElMessageBox.confirm('当前用户已被登出或无权限访问当前资源，请尝试重新登录后再操作。', '无权限访问', {
					type: 'error',
					closeOnClickModal: false,
					center: false,
					confirmButtonText: '重新登录',
					distinguishCancelAndClose: true,
				}).then(() => {
					if(this.$router.path !== '/login') {
						router.replace({ path: '/login' })
					}
					return false
				}).catch(() => {
				})
				return Promise.reject(response)
			}else if(error.response.status == 400){
				ElMessage({
					message:error.response.data.msg || '错误操作',
					type:'warning'
				});
			} else {
				notification.error({
					title: '请求错误',
					message:error.response.data.msg|| error.msg || `Status:${error.response.status}，未知错误！`
				});
			}
			return Promise.reject(error.response);
		}


	}
);

var http = {
	request: function (params) {
		return new Promise((resolve, reject) => {
			axios(params).then(re => {
				const r = re?.data
				if (!r?.code || params.ignore) {
					resolve(r)
					return
				}
				resolve(r.data)
			}).catch((error) => {
				reject(error);
			})
		})

	},
	/** get 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} params
	 * @param  {参数} config
	 */
	get: function (url, params = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'get',
				url: url,
				params: params,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** post 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	post: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'post',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},
	

	/** put 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	put: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'put',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** patch 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	patch: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'patch',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** delete 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	delete: function (url, data = {}, config = {}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'delete',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** jsonp 请求
	 * @param  {接口地址} url
	 * @param  {JSONP回调函数名称} name
	 */
	jsonp: function (url, name = 'jsonp') {
		return new Promise((resolve) => {
			var script = document.createElement('script')
			var _id = `jsonp${Math.ceil(Math.random() * 1000000)}`
			script.id = _id
			script.type = 'text/javascript'
			script.src = url
			window[name] = (response) => {
				resolve(response)
				document.getElementsByTagName('head')[0].removeChild(script)
				try {
					delete window[name];
				} catch (e) {
					window[name] = undefined;
				}
			}
			document.getElementsByTagName('head')[0].appendChild(script)
		})
	}
}

export default http;
